import { type FC } from 'react';

import { FormattedMessage } from 'dibs-react-intl';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import { useLoggedInUser } from 'dibs-buyer-layout/exports/useLoggedInUser';

import styles from './NftProfileEmptyCollection.scss';

type Props = {
    userText: string;
    profileUserId: string | null | undefined;
};

export const NftProfileEmptyCollection: FC<Props> = ({ userText, profileUserId }) => {
    const currentUserId = useLoggedInUser();

    return (
        <div className={styles.container}>
            <HeadingLevel>
                {Heading => (
                    <Heading className={styles.heading}>
                        <FormattedMessage
                            id="nft.publicProfile.noHistory.header"
                            defaultMessage="No NFTs found"
                        />
                    </Heading>
                )}
            </HeadingLevel>

            <p>
                {currentUserId && profileUserId === currentUserId ? (
                    <FormattedMessage
                        id="nft.publicProfile.noHistory.copyActiveUser"
                        defaultMessage="Once you have any activity, it’ll show here."
                    />
                ) : (
                    <FormattedMessage
                        id="nft.publicProfile.noHistory.copyBase"
                        defaultMessage="Once {user} has any activity, it’ll show here."
                        values={{
                            user: userText,
                        }}
                    />
                )}
            </p>
        </div>
    );
};
